import React from 'react'

// ONBOARDING
import DesktopDollarIcon from "product/onboarding/icon-desktop-dollar.svg"
import SmallHomeIcon from 'product/onboarding/icon-small-home.svg'
import RefinanceIcon from 'product/onboarding/icon-refinance.svg'
import HomeIcon from 'product/onboarding/icon-home.svg'
import DollarIcon from 'product/onboarding/icon-dollar.svg'
import HomeStarIcom from 'product/onboarding/icon-home-star.svg'
import SearchIcon from 'product/onboarding/icon-search-home.svg'
import HomeGarageIcon from 'product/onboarding/icon-home-garage.svg'
import CommercialIcon from 'product/onboarding/icon-commercial.svg'
import ApartmentIcon from 'product/onboarding/icon-apartment.svg'
import VacantLandIcon from 'product/onboarding/icon-vacant-land.svg'
import DollarShieldIcon from 'product/onboarding/icon-dollar-shield.svg'
import HandshakeIcon from 'product/onboarding/icon-handshake.svg'
import CalculatorIcon from 'product/onboarding/icon-calculator.svg'
import DollarMineIcon from 'product/onboarding/icon-dollar-mine.svg'
import IdentificationIcon from 'product/onboarding/icon-identification.svg'
import PuzzlePieceIcon from 'product/onboarding/icon-puzzle-piece.svg'
import MediumHomeIcon from 'product/onboarding/icon-medium-home.svg'

// COMMITMENTS
import CommitmentHouseIcon from 'product/application/commitments/icon-house.svg'
import CreditChequeIcon from 'product/application/commitments/icon-credit-cheque.svg'
import CreditCardIcon from 'product/application/commitments/icon-credit-card.svg'
import UserProfileIcon from 'product/application/commitments/icon-user-profile.svg'
import CarIcon from 'product/application/commitments/icon-car.svg'
import ShoppingBagIcon from 'product/application/commitments/icon-shopping-bag.svg'
import BookIcon from 'product/application/commitments/icon-book.svg'
import EllipsisIcon from 'product/application/commitments/icon-ellipsis.svg'

// EXPENSES
import FoodIcon from 'product/application/expenses/basic-minimum-living/icon-food.svg'
import GroceriesIcon from 'product/application/expenses/basic-minimum-living/icon-groceries.svg'
import InsuranceIcon from 'product/application/expenses/basic-minimum-living/icon-insurance.svg'
import MedicalIcon from 'product/application/expenses/basic-minimum-living/icon-medical-expenses.svg'
import TransportIcon from 'product/application/expenses/basic-minimum-living/icon-transport.svg'
import UtilitiesIcon from 'product/application/expenses/basic-minimum-living/icon-utilities.svg'

import PrimaryHomeIcon from 'product/application/expenses/basic-minimum-living/icon-primary-residence.svg'
import StrataFees from 'product/application/expenses/basic-minimum-living/icon-strata-fees.svg'
import FoodAndGroceries from 'product/application/expenses/basic-minimum-living/icon-food-and-groceries.svg'
import MediaStreamingSub from 'product/application/expenses/basic-minimum-living/icon-computer-check.svg'
import Rent from 'product/application/expenses/basic-minimum-living/icon-rent-tag.svg'
import MedicalAndHealth from 'product/application/expenses/basic-minimum-living/icon-heart.svg'
import ClothingAndPersonalCare from 'product/application/expenses/basic-minimum-living/icon-baby-boy-dress.svg'
import PetCare from 'product/application/expenses/basic-minimum-living/icon-pet.svg'
import RecreationAndEntertainment from 'product/application/expenses/basic-minimum-living/icon-play-list-favourite.svg'
import ChildCare from 'product/application/expenses/basic-minimum-living/icon-toys.svg'
import PublicEducation from 'product/application/expenses/basic-minimum-living/icon-school.svg'
import HigherEducation from 'product/application/expenses/basic-minimum-living/icon-hat.svg'
import Transport from 'product/application/expenses/basic-minimum-living/icon-transport.svg'
import GeneralInsurance from 'product/application/expenses/basic-minimum-living/icon-general-insurance.svg'
import HealthInsurance from 'product/application/expenses/basic-minimum-living/icon-heart-shield.svg'
import PersonalInsurance from 'product/application/expenses/basic-minimum-living/icon-life-insurance.svg'
import InvestmentPropertyCosts from 'product/application/expenses/basic-minimum-living/icon-house.svg'
import SecondaryResidence from 'product/application/expenses/basic-minimum-living/icon-house-04.svg'
import OtherRunningExpenses from 'product/application/expenses/basic-minimum-living/icon-cash-02.svg'

import PrimaryHomeIcon2 from 'product/application/expenses/basic-minimum-living/icon-primary-residence-2.svg'
import StrataFees2 from 'product/application/expenses/basic-minimum-living/icon-strata-fees-2.svg'
import FoodAndGroceries2 from 'product/application/expenses/basic-minimum-living/icon-food-and-groceries-2.svg'
import MediaStreamingSub2 from 'product/application/expenses/basic-minimum-living/icon-computer-check-2.svg'
import Rent2 from 'product/application/expenses/basic-minimum-living/icon-rent-tag-2.svg'
import MedicalAndHealth2 from 'product/application/expenses/basic-minimum-living/icon-heart-2.svg'
import ClothingAndPersonalCare2 from 'product/application/expenses/basic-minimum-living/icon-baby-boy-dress-2.svg'
import PetCare2 from 'product/application/expenses/basic-minimum-living/icon-pet-2.svg'
import RecreationAndEntertainment2 from 'product/application/expenses/basic-minimum-living/icon-play-list-favourite-2.svg'
import ChildCare2 from 'product/application/expenses/basic-minimum-living/icon-toys-2.svg'
import PublicEducation2 from 'product/application/expenses/basic-minimum-living/icon-school-2.svg'
import HigherEducation2 from 'product/application/expenses/basic-minimum-living/icon-hat-2.svg'
import Transport2 from 'product/application/expenses/basic-minimum-living/icon-transport-2.svg'
import GeneralInsurance2 from 'product/application/expenses/basic-minimum-living/icon-general-insurance-2.svg'
import HealthInsurance2 from 'product/application/expenses/basic-minimum-living/icon-heart-shield-2.svg'
import PersonalInsurance2 from 'product/application/expenses/basic-minimum-living/icon-life-insurance-2.svg'
import InvestmentPropertyCosts2 from 'product/application/expenses/basic-minimum-living/icon-house-2.svg'
import SecondaryResidence2 from 'product/application/expenses/basic-minimum-living/icon-house-04-2.svg'
import OtherRunningExpenses2 from 'product/application/expenses/basic-minimum-living/icon-cash-02-2.svg'


import ChildIcon from 'product/application/expenses/fixed/icon-child.svg'
import HouseIcon from 'product/application/expenses/fixed/icon-house.svg'
import PackageIcon from 'product/application/expenses/fixed/icon-package.svg'
import PencilIcon from 'product/application/expenses/fixed/icon-pencil.svg'

import MediaIcon from 'product/application/expenses/discretionary/icon-media.svg'
import ClothingIcon from 'product/application/expenses/discretionary/icon-clothing.svg'
import PhoneIcon from 'product/application/expenses/discretionary/icon-phone.svg'
import CutleryIcon from 'product/application/expenses/discretionary/icon-cutlery.svg'
import RunningIcon from 'product/application/expenses/discretionary/icon-running.svg'
import SunIcon from 'product/application/expenses/discretionary/icon-sun.svg'
import TvIcon from 'product/application/expenses/discretionary/icon-tv-play.svg'
import CurrentHomeIcon from 'product/application/personal-details/icon-current-home.svg'

// Profile
import PersonIcon from "product/application/personal-details/icon-person.svg"
import PlaneIcon from "product/application/personal-details/icon-plane.svg"
import ProfileHomeIcon from "product/application/personal-details/icon-home.svg"
import IdIcon from "product/application/personal-details/icon-id.svg"
import ChecklistIcon from "product/application/personal-details/icon-checklist.svg"

// Homepage Calculator
import RefinancingCalculatorIcon from "product/calculator/icon-refinancing-calculator.svg"
import RefinancingCalculatorActiveIcon from "product/calculator/icon-refinancing-calculator-active.svg"
import PurchasingCalculatorIcon from "product/calculator/icon-purchasing-calculator.svg"
import PurchasingCalculatorActiveIcon from "product/calculator/icon-purchasing-calculator-active.svg"

// Review
import ChildMaintenanceIcon from "product/application/incomes/icon-child-maintenance.svg"
import SelfEmployedIcon from "product/application/incomes/icon-self-employed.svg"
import SharesIcon from "product/application/incomes/icon-shares.svg"
import SocialSecurityIcon from "product/application/incomes/icon-social-security.svg"

// Contact us
import EmailIcon from "product/contact-us/icon-email.svg"
import ChatIcon from "product/contact-us/icon-chat.svg"
import MailIcon from "product/contact-us/icon-mail.svg"
import SmalPhoneIcon from "product/contact-us/icon-phone.svg"

import LeftArrow from "product/application/icon-left-arrow.svg"
import RightArrow from "product/application/icon-right-arrow.svg"
import GreenRightArrow from "product/application/icon-green-right-arrow.svg"
import UpArrow from "product/application/icon-up-arrow.svg"
import DownArrow from "product/application/icon-down-arrow.svg"
import PlusIcon from "product/application/icon-plus.svg"
import MinusIcon from "product/application/icon-minus.svg"
import SendIcon from "product/application/icon-send.svg"


// Incomes


class GenericIcon extends React.Component {
  icons = {
    desktopDollar: DesktopDollarIcon,
    smallHome: SmallHomeIcon,
    refinance: RefinanceIcon,
    home: HomeIcon,
    dollar: DollarIcon,
    homeStar: HomeStarIcom,
    search: SearchIcon,
    homeGarage: HomeGarageIcon,
    commercial: CommercialIcon,
    apartment: ApartmentIcon,
    vacantLand: VacantLandIcon,
    dollarShield: DollarShieldIcon,
    handshake: HandshakeIcon,
    calculator: CalculatorIcon,
    dollarMine: DollarMineIcon,
    identification: IdentificationIcon,
    puzzlePiece: PuzzlePieceIcon,
    mediumHome: MediumHomeIcon,
    commitmentHouse: CommitmentHouseIcon,
    creditCheque: CreditChequeIcon,
    creditCard: CreditCardIcon,
    userProfile: UserProfileIcon,
    car: CarIcon,
    shoppingBag: ShoppingBagIcon,
    book: BookIcon,
    ellipsis: EllipsisIcon,
    house: HouseIcon,
    pencil: PencilIcon,
    clothing: ClothingIcon,
    child: ChildIcon,
    pachage: PackageIcon,
    food: FoodIcon,
    groceries: GroceriesIcon,
    insurance: InsuranceIcon,
    medical: MedicalIcon,
    transport: TransportIcon,
    utilities: UtilitiesIcon,


    primaryHome: PrimaryHomeIcon,
    strataFees: StrataFees,
    foodAndGroceries: FoodAndGroceries,
    strataFees: StrataFees,
    mediaStreamingSub: MediaStreamingSub,
    rent: Rent,
    medicalAndHealth: MedicalAndHealth,
    clothingAndPersonalCare: ClothingAndPersonalCare,
    petCare: PetCare,
    recreationAndEntertainment: RecreationAndEntertainment,
    childCare: ChildCare,
    publicEducation: PublicEducation,
    higherEducation: HigherEducation,
    transport: Transport,
    generalInsurance: GeneralInsurance,
    healthInsurance: HealthInsurance,
    personalInsurance: PersonalInsurance,
    investmentPropertyCosts: InvestmentPropertyCosts,
    secondaryResidence: SecondaryResidence,
    otherRunningExpenses: OtherRunningExpenses,

    primaryHomeFocus: PrimaryHomeIcon2,
    strataFeesFocus: StrataFees2,
    foodAndGroceriesFocus: FoodAndGroceries2,
    strataFeesFocus: StrataFees2,
    mediaStreamingSubFocus: MediaStreamingSub2,
    rentFocus: Rent2,
    medicalAndHealthFocus: MedicalAndHealth2,
    clothingAndPersonalCareFocus: ClothingAndPersonalCare2,
    petCareFocus: PetCare2,
    recreationAndEntertainmentFocus: RecreationAndEntertainment2,
    childCareFocus: ChildCare2,
    publicEducationFocus: PublicEducation2,
    higherEducationFocus: HigherEducation2,
    transportFocus: Transport2,
    generalInsuranceFocus: GeneralInsurance2,
    healthInsuranceFocus: HealthInsurance2,
    personalInsuranceFocus: PersonalInsurance2,
    investmentPropertyCostsFocus: InvestmentPropertyCosts2,
    secondaryResidenceFocus: SecondaryResidence2,
    otherRunningExpensesFocus: OtherRunningExpenses2,

    cutlery: CutleryIcon,
    running: RunningIcon,
    sun: SunIcon,
    tv: TvIcon,
    phone: PhoneIcon,
    media: MediaIcon,
    currentHome: CurrentHomeIcon,
    person: PersonIcon,
    plane: PlaneIcon,
    profileHome: ProfileHomeIcon,
    id: IdIcon,
    checklist: ChecklistIcon,
    refinancing: RefinancingCalculatorIcon,
    refinancingActive: RefinancingCalculatorActiveIcon,
    purchasing: PurchasingCalculatorIcon,
    purchasingActive: PurchasingCalculatorActiveIcon,
    childMaintenance: ChildMaintenanceIcon,
    selfEmployed: SelfEmployedIcon,
    shares: SharesIcon,
    socialSecurity: SocialSecurityIcon,
    email: EmailIcon,
    chat: ChatIcon,
    mail: MailIcon,
    smallPhone: SmalPhoneIcon,
    leftArrow: LeftArrow,
    rightArrow: RightArrow,
    greenRightArrow: GreenRightArrow,
    plusIcon: PlusIcon,
    minusIcon: MinusIcon,
    sendIcon: SendIcon,
    upArrow: UpArrow,
    dowArrow: DownArrow,
  }

  render() {
    const IconName = this.icons[this.props.name];

    if (IconName == undefined) {
      return null
    }
    return(
      <IconName id={this.props.id} className={ this.props.className } />
    )
  }
}
export default GenericIcon;
